const nameDaily = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
const monthly = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];

const dailyIds = (shift = 0) => {
  const days = [];
  let offset = 0;

  while (days.length < 5) {
    const d = new Date();
    d.setDate(d.getDate() - offset + (shift * 7));

    const dayOfWeek = d.getDay(); // 0=domingo, 6=sábado

    // Solo lunes (1) a viernes (5)
    if (dayOfWeek >= 1 && dayOfWeek <= 5) {
      days.push(`${d.getDate()}-${d.getMonth() + 1}-${d.getFullYear()}`);
    }

    offset++;
  }

  return days.reverse();
};

const monthlyIds = (shift = 0) => {
  // últimos 6 meses
  const months = [];
  for (let i = 0; i < 5; i++) {
    const d = new Date();
    d.setMonth(d.getMonth() - i + (shift * 5));
    months.push(`${d.getMonth() + 1}-${d.getFullYear()}`); // "1-2026"
  }
  return months.reverse();
};

const quarterlyIds = (shift = 0) => {
  // 4 trimestres (1 año). shift mueve por años.
  const quarters = [];
  for (let i = 0; i < 4; i++) {
    const d = new Date();
    d.setMonth(d.getMonth() - i * 3 + (shift * 12));
    const q = Math.floor(d.getMonth() / 3) + 1;
    const y = d.getFullYear();
    quarters.push(`Q${q}-${y}`); // "Q1-2026"
  }
  return quarters.reverse();
};

const yearlyIds = (shift = 0) => {
  // últimos 4 años. shift mueve por bloques de 5.
  const years = [];
  for (let i = 0; i < 4; i++) {
    const d = new Date();
    d.setFullYear(d.getFullYear() - i + (shift * 4));
    years.push(String(d.getFullYear())); // "2026"
  }
  return years.reverse();
};

const createDate = (id) => {
  const [dia, mes, anio] = id.split('-').map(Number);
  return new Date(anio, mes - 1, dia);
};

const createDateMonth = (id) => {
  const [mes, anio] = id.split('-').map(Number);
  return new Date(anio, mes - 1, 1);
};

export const Labels = (shift) => {
  const dIds = dailyIds(shift);
  const mIds = monthlyIds(shift);
  const qIds = quarterlyIds(shift);
  const yIds = yearlyIds(shift);

  return {
    daily: dIds.map(id => {
      const d = createDate(id);
      return `${nameDaily[d.getDay()].slice(0, 3)} ${d.getDate()}-${d.getMonth() + 1}`;
    }),
    dailyIds: dIds,

    monthly: mIds.map(id => {
      const d = createDateMonth(id);
      return `${monthly[d.getMonth()]}'${String(d.getFullYear()).slice(2)}`;
    }),
    monthlyIds: mIds,

    quarterly: qIds.map(qid => {
      const [q, y] = qid.split('-'); // Q1-2026
      return `${q}'${String(y).slice(2)}`; // Q1'26
    }),
    quarterlyIds: qIds,

    yearly: yIds,
    yearlyIds: yIds
  };
};

export const monthlyNames = monthly;

export default Labels;